import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';

import { useInputInsertText } from './useInputInsertText';

type InsertPlaceholderMethod = (text: string) => void;

export const useInsertPlaceholder = (
  inputRef: React.RefObject<HTMLInputElement | HTMLTextAreaElement>,
  setFieldValue: (newValue: string) => void,
): InsertPlaceholderMethod => {
  const insertText = useInputInsertText(inputRef, setFieldValue);

  return useCallbackRef((text: string) => {
    const placeholderText = `[${text}]`;
    insertText(placeholderText);
  });
};
